// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__1CCNA","content":"style_content__204bC","text":"style_text__8P9Mf"};